const path = `examineeanswers`;

export const state = {
};

export const getters = {
};

export const mutations = {
};

export const actions = {

	saveAnswers(store, data) {
		return this._vm.$http.post(`/${path}/`, data);
	},
	
	getAllOfExaminees(store, data) {
		return this._vm.$http.post(`/${path}/ofexaminees`, data);
	},
	
	// --- Generic Methods
	[`fields`]() {
		return this._vm.$http.get(`/${path}/fields`);
	},
	[`getAll`]() {
		return this._vm.$http.get(`/${path}`);
	},
	[`getAllOfClient`](store, {clientId}) {
		return this._vm.$http.get(`/${path}/ofclient/${clientId}`);
	},
	[`get`](store, { id }) {
		return this._vm.$http.get(`/${path}/${id}`);
	},
	[`getFull`](store, { id }) {
		return this._vm.$http.get(`/${path}/full/${id}`);
	},
	[`create`](store, data) {
		return this._vm.$http.post(`/${path}`, data);
	},
	[`update`](store, { id, data }) {
		return this._vm.$http.put(`/${path}/${id}`, data);
	},
	[`delete`](store, { id }) {
		return this._vm.$http.delete(`/${path}/${id}`);
	},
	[`deleteAll`]() {
		return this._vm.$http.delete(`/${path}`);
	},
};
